document.addEventListener("DOMContentLoaded", function () {
  /**
   * Skip link on all the sections
   */
  document.querySelectorAll(".skip-link").forEach((link) => {
    const skipLinkHandler = (e) => {
      e.preventDefault();
      if (!link.hash) return;

      const target = document.querySelector(link.hash);
      if (!target) return;

      const offset = 200;
      const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({ top: y, behavior: "smooth" });

      target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
    };

    link.addEventListener("click", skipLinkHandler);
    link.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") skipLinkHandler(e);
    });
  });

  /**
   * Add aria-labelledby attribute for all sections
   */
  const sections = document.querySelectorAll("section");
  sections.forEach((section) => {
    const id = section.getAttribute("id");
    if (id) {
      const headingId = id + "-heading";
      const heading = section.querySelector("h1, h2");
      if (heading) {
        heading.setAttribute("id", headingId);
        section.setAttribute("aria-labelledby", headingId);
      }
    }
  });

  /**
   * Header menu accessibility - Desktop
   */

  const megaMenus = document.querySelectorAll(".menu-dropdown--mega");

  megaMenus.forEach((menu) => {
    const trigger = menu.querySelector(".main-menu__trigger");
    const panel = menu.querySelector(".menu-dropdown__content--megamenu");

    if (!trigger || !panel) return;

    trigger.setAttribute("aria-expanded", "false");
    panel.setAttribute("aria-hidden", "true");

    function openMenu() {
      trigger.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");
      menu.classList.add("is-open");
    }

    function closeMenu() {
      trigger.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
      menu.classList.remove("is-open");
    }

    function toggleMenu() {
      const expanded = trigger.getAttribute("aria-expanded") === "true";
      expanded ? closeMenu() : openMenu();
    }

    // Enter / Space
    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleMenu();
        if (trigger.getAttribute("aria-expanded") === "true") {
          const firstLink = panel.querySelector("a, button, input, select, textarea, [tabindex]:not([tabindex='-1'])");
          if (firstLink) {
            firstLink.focus();
          }
        }
      }

      if (e.key === "Escape") {
        closeMenu();
        trigger.focus();
      }
    });

    // Click event
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      toggleMenu();
    });

    // Hover support
    menu.addEventListener("mouseenter", openMenu);
    menu.addEventListener("mouseleave", closeMenu);

    // Escape inside menu
    panel.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeMenu();
        trigger.focus();
      }
    });

    trigger.addEventListener("focus", openMenu);

    // Close when focus leaves the whole menu
    menu.addEventListener("focusout", function () {
      requestAnimationFrame(() => {
        if (!menu.contains(document.activeElement)) {
          closeMenu();
        }
      });
    });
  });

  /**
   * Header menu accessibility - Mobile
   */
  const mobileMenu = document.querySelector(".menu-mobile");
  const mobileNav = mobileMenu.querySelector(".menu-mobile__nav");

  const openButton = document.querySelector(".button-menu .js-menu-mobile");
  const closeButton = document.querySelector(".menu-mobile__inner .js-menu-mobile");

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
  }

  function closeMobileMenu() {
    openButton.setAttribute("aria-expanded", "false");
    mobileNav.setAttribute("aria-hidden", "true");

    openButton.focus();
  }

  mobileMenu.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;

    const focusables = getFocusableElements(mobileMenu);

    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  mobileMenu.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && $("body").hasClass("menu-mobile--open")) {
      $("body").removeClass("menu-mobile--open");

      openButton.attr("aria-expanded", "false").trigger("focus");

      mobileNav.attr("aria-hidden", "true");
    }
  });

  /**
   * Add to wishlist
   */
  // Sync all wishlist buttons
  function syncWishlistAria(btn, announce = false) {
    const handle = btn.dataset.productHandle;
    const status = document.getElementById(`wishlist-status-${handle}`);
    const isAdded = btn.classList.contains("active");

    // Announce ONLY when explicitly allowed
    if (announce && status) {
      status.textContent = isAdded ? "Added to wishlist" : "Removed from wishlist";
    }
  }

  function observeWishlistButton(btn) {
    let lastState = btn.classList.contains("active");

    const observer = new MutationObserver(() => {
      const currentState = btn.classList.contains("active");

      // ✅ Prevent duplicate announcements
      if (currentState === lastState) return;

      lastState = currentState;

      syncWishlistAria(btn, true); // announce here
    });

    observer.observe(btn, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function initWishlistAccessibility(context = document) {
    const buttons = context.querySelectorAll(".wishlist-btn");

    buttons.forEach((btn) => {
      syncWishlistAria(btn, false); // initial sync, NO announcement
      observeWishlistButton(btn);
    });
  }

  initWishlistAccessibility();

  // Mouse / touch
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;
  });

  // Keyboard support
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;

    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;

    e.preventDefault();
    btn.click(); // triggers existing wishlist logic
  });

  /**
   * Remove from wishlist
   */
  function announceWishlistRemoval(productName) {
    const liveRegion = document.getElementById("global-status");

    // Clear first to force re-announcement
    liveRegion.textContent = "";
    setTimeout(() => {
      liveRegion.textContent = `${productName} removed from wishlist`;
    }, 50);
  }

  // Remove click handler
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".remove-wishlist-btn.active");
    if (!btn) return;

    const card = btn.closest(".product-content-card");
    if (!card) return;

    const productName = btn.dataset.productName;

    announceWishlistRemoval(productName);

    // Remove after announcement is queued
    setTimeout(() => {
      card.remove();
    }, 100);
  });

  // Keyboard support
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;

    const btn = e.target.closest(".remove-wishlist-btn");
    if (!btn) return;

    e.preventDefault();
    btn.click(); // triggers existing wishlist logic
  });

  /**
   * Mini Cart, Cart - Aria Labels
   */
  jQuery(document).ready(function ($) {
    $(".cart-total__buttons .btn.cart-modal__btn").attr("aria-label", "Proceed to Checkout page");
  });

  /**
   * Add aria-labels to all the prev and next buttons of the slick slider
   */
  const sliderNavObserver = new MutationObserver(() => {
    document.querySelectorAll(".slick__arrow--previous:not([aria-label])").forEach((btn) => btn.setAttribute("aria-label", "Previous slide"));

    document.querySelectorAll(".slick__arrow--next:not([aria-label])").forEach((btn) => btn.setAttribute("aria-label", "Next slide"));
  });

  sliderNavObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  /**
   * Slick slider announce slide change through screenreader
   */
  let globalStatus = document.getElementById("global-status");

  const productMediaSliders = document.querySelectorAll(".js-product-media-group");

  productMediaSliders.forEach((slider) => {
    // Make sure Slick is already initialized
    if (!slider.classList.contains("slick-initialized")) return;

    const slickInstance = $(slider).slick("getSlick");

    // Initial announcement (important!)
    globalStatus.textContent = `Slide ${slickInstance.currentSlide + 1} of ${slickInstance.slideCount}`;

    // Announce on navigation
    $(slider).on("afterChange", function (e, slick, currentSlide) {
      globalStatus.textContent = `Slide ${currentSlide + 1} of ${slick.slideCount}`;
    });
  });
});
